import React, { useEffect, useState } from 'react';
import { Download, Eye, FileText, Loader2 } from 'lucide-react';
import { api } from '../context/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';

const QUELLEN = [['cv', 'Lebenslauf'], ['pdf', 'Gesamte Bewerbung']];

const Anzeige = ({ it, quelle }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    let url;
    setD(null);
    api.get(`/admin/anfragen/bewerbungen/${it.bewerbung_id}/${quelle}`, { responseType: 'blob' })
      .then((r) => { const typ = r.headers['content-type'] || 'application/pdf'; url = URL.createObjectURL(new Blob([r.data], { type: typ })); setD({ url, typ }); })
      .catch((e) => setD({ fehler: e?.response?.status === 404 ? 'Keine Datei vorhanden.' : 'Vorschau konnte nicht geladen werden.' }));
    return () => url && URL.revokeObjectURL(url);
  }, [it.bewerbung_id, quelle]);
  if (!d) return <div className="h-[65vh] flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#b8893d]" /></div>;
  if (d.fehler) return <div className="h-40 flex items-center justify-center text-sm text-gray-500" data-testid="bewerbung-vorschau-fehler">{d.fehler}</div>;
  const name = `${quelle === 'cv' ? 'Lebenslauf' : 'Bewerbung'}_${(it.name || 'Bewerber').replace(/\s+/g, '_')}`;
  return (
    <div className="space-y-2">
      {d.typ.startsWith('image/') ? <img src={d.url} alt={name} className="max-h-[65vh] mx-auto rounded-lg border border-gray-200" />
        : d.typ.includes('pdf') ? <iframe title={name} src={d.url} className="w-full h-[65vh] rounded-lg border border-gray-200 bg-white" data-testid="bewerbung-vorschau-frame" />
          : <p className="text-sm text-gray-500 py-8 text-center">Für dieses Dateiformat gibt es keine Vorschau. Bitte herunterladen.</p>}
      <a href={d.url} download={name} className="inline-flex items-center gap-1.5 h-8 px-3 text-xs rounded-[10px] border border-gray-200 text-[#1B3A5C] hover:border-[#b8893d] transition-colors duration-200" data-testid="bewerbung-vorschau-download"><Download className="w-3.5 h-3.5" />Herunterladen</a>
    </div>
  );
};

export const BewerbungVorschau = ({ it }) => {
  const [offen, setOffen] = useState(false);
  const [quelle, setQuelle] = useState(it.cv?.gridfs_id ? 'cv' : 'pdf');
  return (
    <>
      <button type="button" onClick={() => setOffen(true)} className="inline-flex items-center gap-1.5 px-3 py-1.5 text-[11px] tracking-wider rounded-sm border border-[#b8893d] text-[#1B3A5C] hover:bg-[#b8893d] hover:text-white transition-colors duration-200" data-testid={`bewerbung-vorschau-${it.bewerbung_id}`}>
        <Eye className="w-3.5 h-3.5" /> UNTERLAGEN ANSEHEN
      </button>
      <Dialog open={offen} onOpenChange={setOffen}>
        <DialogContent className="max-w-4xl" data-testid={`bewerbung-vorschau-dialog-${it.bewerbung_id}`}>
          <DialogHeader><DialogTitle className="font-serif text-[#1B3A5C] flex items-center gap-2"><FileText className="w-5 h-5 text-[#b8893d]" />{it.name} · {it.position || 'Bewerbung'}</DialogTitle></DialogHeader>
          <div className="inline-flex p-1 rounded-full bg-[#f5f8fa] border border-gray-200 w-fit" role="tablist">
            {QUELLEN.filter(([k]) => k !== 'cv' || it.cv?.gridfs_id).map(([k, l]) => (
              <button key={k} type="button" role="tab" aria-selected={quelle === k} onClick={() => setQuelle(k)} data-testid={`bewerbung-vorschau-tab-${k}`}
                className={`h-8 px-4 rounded-full text-xs transition-colors duration-200 ${quelle === k ? 'bg-[#1B3A5C] text-white' : 'text-[#1B3A5C] hover:bg-white'}`}>{l}</button>
            ))}
          </div>
          {it.message && quelle === 'cv' && <p className="text-xs text-[#34536b] bg-[#fbf7f0] border-l-2 border-[#b8893d] px-3 py-2 whitespace-pre-line max-h-24 overflow-y-auto" data-testid="bewerbung-vorschau-nachricht">{it.message}</p>}
          {offen && <Anzeige it={it} quelle={quelle} />}
        </DialogContent>
      </Dialog>
    </>
  );
};
